'use strict';

function ColorpickerDirective ($compile, $interpolate, $templateCache) {

  function link (scope, el, attrs, ctrl) {

    var wrapperEl = angular.element(el.children()[0]);
    var row = $templateCache.get('saturn/colorpicker/colorpicker-row.tpl.html');
    var colors = ctrl.colors;

    // This is an alternative to using ng-repeat and is implemented mainly as an experiment but
    // has the additional benefit of being more performant than ng-repeat; the reason being that
    // nothing is being added to Angular's $$watchers list.
    //
    // @see http://www.binpress.com/tutorial/speeding-up-angular-js-with-simple-optimizations/135
    for (var i = 0; i < colors.length; i++) {
      var color = colors[i];
      var fn = $interpolate(row);

      var context = {
        color: color
      };

      var rowEl = angular.element(fn(context));

      rowEl.css({
        backgroundColor: color
      });

      wrapperEl.append(rowEl);
    }

    $compile(wrapperEl)(scope);
  }

  return {
    bindToController: true,
    controller: 'sbColorpickerController',
    controllerAs: 'ctrl',
    link: link,
    scope: {
      activeColor: '=?',
      defaultColor: '=?',
      colors: '=?'
    },
    template: '<div class="colorpicker"></div>'
  };
}

module.exports = ColorpickerDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/colorpicker/src/ColorpickerDirective.js